export default __webpack_public_path__ + "static/media/35_Kane_lesni_Saj_cmmj_thumb-min.5e758f3b.jpg";